/**
 * NOTE: Not unit tested due to too much mocking.
 */

import { useEffect, useState } from 'react'

interface UseOnScreenProps {
	threshold?: number
	rootMargin?: string
	once?: boolean
}

export const useOnScreen = (
	ref: { current: Element },
	props: UseOnScreenProps = {}
): boolean => {
	const { threshold = 0, rootMargin = '0px', once = false } = props
	const [isIntersecting, setIntersecting] = useState(false)

	useEffect(() => {
		const element = ref.current

		const observer = new IntersectionObserver(
			([entry]) => {
				setIntersecting(entry.isIntersecting)

				// If once is true and element is intersecting, unobserve immediately
				if (once && entry.isIntersecting && element) {
					observer.unobserve(element)
				}
			},
			{
				threshold,
				rootMargin,
			}
		)

		if (element) {
			observer.observe(element)
		}

		return () => {
			if (element) {
				observer.unobserve(element)
			}
		}
	}, [ref, threshold, rootMargin, once])

	return isIntersecting
}
